(() => {
  const init = (root) => {
    if (root.dataset.gjPdpReady) return;
    const configNode = root.querySelector('[data-gj-pdp-config]');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    root.dataset.gjPdpReady = 'true';
    const sectionId = config.sectionId;
    const form = document.getElementById(`product-form-${sectionId}`);
    const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!form || !mainButton) return;
    const info = root.querySelector('.product__info-container');
    let frame;
    const estimate = root.querySelector('[data-gj-delivery]');
    const express = root.querySelector('[data-gj-express]');
    const businessDays = (start, count) => {
      const day = new Date(start);
      while (count > 0) {
        day.setUTCDate(day.getUTCDate() + 1);
        if (day.getUTCDay() !== 0 && day.getUTCDay() !== 6) count--;
      }
      return day;
    };
    const updateDelivery = () => {
      if (!estimate) return;
      if (config.ready) {
        estimate.textContent = config.readyNote;
        return;
      }
      const today = new Intl.DateTimeFormat('en-CA', { timeZone:'Australia/Melbourne', year:'numeric', month:'2-digit', day:'2-digit' }).format(new Date());
      const dispatch = new Date(`${today}T12:00:00Z`);
      dispatch.setUTCDate(dispatch.getUTCDate() + (express?.checked ? config.expressDays : config.standardDays));
      while ([0,6].includes(dispatch.getUTCDay())) dispatch.setUTCDate(dispatch.getUTCDate() + 1);
      const format = (date) => new Intl.DateTimeFormat('en-AU', { timeZone:'UTC', day:'numeric', month:'short' }).format(date);
      const primary = document.createElement('strong');
      primary.textContent = config.dispatch.replace('[date]', format(dispatch));
      const detail = document.createElement('span');
      detail.textContent = config.country === 'AU'
        ? config.delivery.replace('[range]', `${format(businessDays(dispatch, config.transitMin))}–${format(businessDays(dispatch, config.transitMax))}`)
        : config.internationalNote;
      const note = document.createElement('small');
      note.textContent = config.estimateNote;
      estimate.replaceChildren(primary, detail, note);
    };
    const bar = document.querySelector(`[data-gj-pdp-sticky="${sectionId}"]`);
    const stickyButton = bar?.querySelector('button');
    const stickyPrice = bar?.querySelector('[data-gj-sticky-price]');
    const instalments = bar?.querySelector('[data-gj-sticky-instalments]');
    const syncGuides = () => {
      root.querySelectorAll('.gj-option-guide').forEach(guide => {
        if (guide.dataset.hoverBound) return;
        guide.dataset.hoverBound = 'true';
        const summary = guide.querySelector('summary');
        let pinned = guide.open;
        summary.addEventListener('click', event => {
          event.preventDefault();
          pinned = !pinned;
          guide.open = pinned;
        });
        guide.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover) and (pointer:fine)').matches) guide.open = true; });
        guide.addEventListener('mouseleave', () => { if (!pinned && !guide.contains(document.activeElement)) guide.open = false; });
        guide.addEventListener('focusin', () => { guide.open = true; });
        guide.addEventListener('focusout', event => { if (!pinned && !guide.contains(event.relatedTarget) && !guide.matches(':hover')) guide.open = false; });
        guide.addEventListener('keydown', event => { if (event.key === 'Escape') { pinned = false; guide.open = false; } });
      });
      root.querySelectorAll('[data-gj-stone-guide]').forEach(guide => {
        const figures = [...guide.querySelectorAll('[data-gj-stone-value]')];
        const values = figures.map(figure => {
          const label = figure.dataset.gjStoneValue;
          const ct = label.match(/([\d.]+)\s*(?:ct|carat)/i);
          const mm = label.match(/([\d.]+)\s*[x×]\s*([\d.]+)\s*mm/i);
          const diameter = !mm && label.match(/([\d.]+)\s*mm/i);
          return { carat: ct ? Number(ct[1]) : 1, width: mm ? Number(mm[1]) : diameter ? Number(diameter[1]) : null, height: mm ? Number(mm[2]) : diameter ? Number(diameter[1]) : null };
        });
        const hasDimensions = values.every(value => value.width > 0 && value.height > 0);
        const max = Math.max(...values.map(value => value.carat), 1);
        const maxDimension = Math.max(...values.map(value => Math.max(value.width || 0, value.height || 0)), 1);
        const field = guide.closest('.product-form__input')?.querySelector('select') || guide.previousElementSibling?.querySelector('select');
        figures.forEach((figure, index) => {
          const value = values[index];
          const scale = Math.cbrt(Math.max(value.carat, 0.1) / max);
          const ratio = Number(guide.dataset.gjStoneRatio) || 1;
          const sx = hasDimensions ? value.width / maxDimension : scale * ratio;
          const sy = hasDimensions ? value.height / maxDimension : scale;
          figure.querySelector('[data-gj-stone-outline]').setAttribute('transform', `translate(32 36) scale(${sx} ${sy}) translate(-32 -36)`);
          if (field) figure.classList.toggle('is-selected', figure.dataset.gjStoneValue === field.value);
        });
      });
    };
    const missingOption = () => [...form.elements].find((field) => field.willValidate && !field.validity.valid);
    const syncSticky = () => {
      if (!bar) return;
      const bounds = mainButton.getBoundingClientRect();
      const keyboard = ['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName);
      // Reveal only after the customer has passed the main purchase button.
      bar.hidden = bounds.bottom > 0 || keyboard || !mainButton.getClientRects().length;
      const total = root.querySelector('.gj-native-total:not([hidden]) [data-gj-total-value]');
      const price = total || root.querySelector('.price--on-sale .price__sale .price-item--sale') || root.querySelector('.price__regular .price-item');
      if (price && stickyPrice.textContent !== price.textContent) stickyPrice.textContent = price.textContent;
      if (price) stickyPrice.hidden = false;
      else stickyPrice.hidden = true;
      const source = root.querySelector('[data-gj-native-price]');
      const displayedAmount = price?.textContent.match(/[\d,]+(?:\.\d{2})?/);
      const cents = displayedAmount ? Math.round(Number(displayedAmount[0].replace(/,/g, '')) * 100) : NaN;
      const extra = 0;
      if (instalments) {
        const currency = source?.dataset.currency || 'AUD';
        instalments.hidden = !Number.isFinite(cents) || currency !== 'AUD' || cents + extra > 400000;
        if (!instalments.hidden) {
          const quarter = new Intl.NumberFormat('en-AU', { style:'currency', currency:'AUD', currencyDisplay:'narrowSymbol' }).format((cents + extra) / 400);
          const note = `4 × ${quarter} with Afterpay`;
          if (instalments.textContent !== note) instalments.textContent = note;
        }
      }
      const busy = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = busy;
      const label = mainButton.hasAttribute('data-gj-quote') || mainButton.disabled ? mainButton.textContent.trim() : missingOption() ? config.chooseOptions : config.addToCart;
      if (stickyButton.textContent !== label) stickyButton.textContent = label;
    };
    stickyButton?.addEventListener('click', () => {
      if (mainButton.hasAttribute('data-gj-quote')) {
        mainButton.click();
        return;
      }
      const missing = missingOption();
      if (missing) {
        const ancestor = missing.closest('details');
        if (ancestor) ancestor.open = true;
        missing.scrollIntoView({ behavior:'smooth', block:'center' });
        missing.focus({ preventScroll:true });
      } else mainButton.click();
    });
    const larger = root.querySelector('[data-gj-size-request]');
    larger?.addEventListener('input', () => {
      larger.name = larger.value.trim() ? 'properties[Ring size override - confirm before crafting]' : '';
    });
    const refresh = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { syncGuides(); syncSticky(); });
    };
    const observer = new MutationObserver(refresh);
    observer.observe(info, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled'] });
    root.addEventListener('change', refresh);
    root.addEventListener('input', refresh);
    express?.addEventListener('change', updateDelivery);
    window.addEventListener('scroll', syncSticky, { passive:true });
    window.addEventListener('resize', syncSticky, { passive:true });
    document.addEventListener('focusin', syncSticky);
    document.addEventListener('focusout', () => requestAnimationFrame(syncSticky));
    updateDelivery();
    syncGuides();
    syncSticky();
  };
  const boot = () => document.querySelectorAll('.gj-pdp-v2').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
